// TODO remove after backend response dto changes
export const abbreviateUser = (firstName: string, lastName: string, middleName: string) => {
	const abbreviate = (value: string) => value?.substring(0, 1).toUpperCase();
	return `${lastName} ${abbreviate(firstName)}. ${abbreviate(middleName)}.`;
};
